import { HttpClient} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BACKEND_URLS } from 'app/app.config';
import { User } from 'app/core/user/user.types';
import { map, Observable, ReplaySubject, tap } from 'rxjs';

@Injectable({providedIn: 'root'})
export class UserService
{
    private _httpClient = inject(HttpClient);
    private backendUrls = inject(BACKEND_URLS);


    public _user: ReplaySubject<User> = new ReplaySubject<User>(1);

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: User)
    {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<User>
    {
        return this._user.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current signed-in user data
     */
    get(): Observable<User>
    {
        return this._httpClient.get<User>(`${this.backendUrls.backendApiUrl}/user`).pipe(
            tap((user) =>
            {
                this._user.next(user);
            }),
        );
    }

    /**
     * Update the user
     *
     * @param user
     */
    update(user: User): Observable<any>
    {
        return this._httpClient.patch<User>(`${this.backendUrls.backendApiUrl}/user`, {user}).pipe(
            map((response) =>
            {
                this._user.next(response);
            }),
        );
    }

    logout(){



        this._user.next(null);
    }

    //signOut ()

    signOut() {

        return this._httpClient.post(`${this.backendUrls.backendApiUrl}/login/sign_out`, {})
    }



}



